import { buildAdminPath } from './adminPath'
import { resolveAdminExtensionRouteByKey } from '../../components/admin-shell/admin-extension-registry'

export const buildDashboardPath = (
  section: string,
  selectedShopProductId: string | null,
  selectedUserId: string | null,
): string => {
  if (section === 'dashboard') return buildAdminPath('/')
  if (section === 'site-email-templates') return buildAdminPath('/communications/email-templates')
  if (section === 'site-email-logs') return buildAdminPath('/system/email-logs')
  if (section === 'profile-contact') return buildAdminPath('/account/profile')
  if (section === 'profile-security') return buildAdminPath('/account/security')
  if (section === 'profile-sessions') return buildAdminPath('/account/sessions')
  if (section === 'audit-logs') return buildAdminPath('/account/audit')
  if (section === 'profile-danger') return buildAdminPath('/account/privacy')
  if (section === 'profile-addresses') return buildAdminPath('/account/preferences')
  if (section === 'profile-team') return buildAdminPath('/account/team')
  if (section === 'profile-team-edit') {
    if (selectedUserId) {
      return buildAdminPath(`/account/team/edit/${encodeURIComponent(selectedUserId)}`)
    }
    return buildAdminPath('/account/team')
  }
  if (section === 'shop-products' && selectedShopProductId) {
    return buildAdminPath(`/products/${encodeURIComponent(selectedShopProductId)}/edit`)
  }
  if (section === 'shop-products') return buildAdminPath('/products')
  const extensionRoute = resolveAdminExtensionRouteByKey(section)
  if (extensionRoute) {
    return extensionRoute.routePath
  }
  if (section.startsWith('ext:')) {
    return buildAdminPath('/')
  }
  return buildAdminPath(`/${encodeURIComponent(section)}`)
}
